import {AFD} from 'devegram-javascript-util'

const baseUrl = '/xapi/Voip/Broadcast';
const baseUrl2 = '/xapi/VoipMrt/Broadcast';
const moduleAjaxService = 'backend-service'
const api = {
    namespaced: true,
    state: {},
    actions: {
        async getBroadcastData(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + encodeURIComponent(params.id),
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getUsersFusionServer(context, records) {
            let api = {
                verb: 'POST',
                service: moduleAjaxService,
                url: baseUrl + '/getUsersFusionServer',
                data: records
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getAutomationTestHistory(context, params) {
            let statusId = '&status_id=' + params.statusId
            let page = '&page=' + params.page
            let divisionId = '&division_id=' + params.divisionId
            let search = (params.hasOwnProperty('search'))? "&search=" + encodeURIComponent(params.search) : ''
            let automation_test_id = "&automation_test_id=" + params.automation_test_id

            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getAutomationTestHistory?' + automation_test_id + page + statusId + divisionId + search
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getBroadcastHistory(context, params) {
            
            let userId = 'user_id=' + params.userId
            let statusId = '&status_id=' + params.statusId
            
            let isVerified = (params.hasOwnProperty('isVerified'))? "&isVerified=" + params.isVerified : ''
            let page = '&page=' + params.page
            let division = (params.hasOwnProperty('division') && params)? ('&division=' + params.division) : '&division='
            let divisionId = (params.hasOwnProperty('division_id'))? ('&division_id=' + params.division_id) : ''
            let showAll = "&showAll=" + params.showAll
            let search = (params.hasOwnProperty('search'))? "&search=" + encodeURIComponent(params.search) : ''
            let aniSearch = (params.hasOwnProperty('aniSearch'))? "&aniSearch=" + encodeURIComponent(params.aniSearch) : ''
            let get_automation = (params.hasOwnProperty('get_automation'))? "&get_automation=" + params.get_automation : ''
            let get_automation_without_action = (params.hasOwnProperty('get_automation_without_action'))? "&get_automation_without_action=" + params.get_automation_without_action : ''


            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getBroadcastHistory?' + userId + statusId + page + division + showAll + search + aniSearch + get_automation + get_automation_without_action + divisionId + isVerified,
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getMrtBroadcastHistory(context, params) {
            let userId = 'user_id=' + params.userId
            let statusId = '&status_id=' + params.statusId
            let page = '&page=' + params.page
            let division = '&division=' + params.division
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl2 + '/getBroadcastHistory?' + userId + statusId + page + division,
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getRatePanelInfo(context, params) {
            let rateId = params.rateId
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getRatePanelInfo?rate_id=' + rateId,
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getBroadcastCdr(context, params) {
            let live = false;
            if (params.hasOwnProperty('live') && params['live']) {
                live = true
            }
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getBroadcastCdr/' + params.id,
                noLoadingScreen: true,
            };

            if (live) timeout: 60 * 4 * 1000 // 4 mins

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        }, async getBroadcastCdrByPublicId(context, params) {
            let baseToUse = baseUrl
            if (params.hasOwnProperty('mrt')) {
                baseToUse= baseUrl2
            }
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseToUse + '/getBroadcastCdrByPublicId?id=' + params.publicId,
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getUserTestingPanelSetting(context) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getUserTestingPanelSetting',
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getUserTestingPanelTestTypes(context) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getUserTestingPanelTestTypes',
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async panelUserTest(context, params) {

            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/panelUserTest',
                data: AFD(params.data),
                timeout: 60 * 4 * 1000 // 4 mins
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async panelUserTestMRT(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl2 + '/panelUserTest',
                data: AFD(params.data),
                timeout: 60 * 4 * 1000 // 4 mins
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            }, error => {
                if (!error.response || error.code === 'ECONNABORTED') {
                    reject('ECONNABORTED');
                }
            })
        },
        async create(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/store',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async update(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/update/' + params.id,
                data: AFD(params.data),
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async remove(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/remove/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async downloadBroadcastReport(context, params) {
            let status = params.status
            let divisionLabel = params.divisionLabel
            let percentage = params.percentage
            let downloadMode = params.downloadMode
            let pushListNumberOfDestinations = params.pushListNumberOfDestinations

            let fileName = 'ffr-customer-vos-rate'
            let fileType = 'xlsx'

            const link = document.createElement('a');
            link.href = process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_URL + ":" + process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_PORT + baseUrl + '/downloadBroadcastReport/' + status + '/' + encodeURIComponent(divisionLabel) + '/' + percentage + '/' + downloadMode + '/' + pushListNumberOfDestinations;
            link.setAttribute('download', fileName + '.' + fileType);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async get(context, params) {
            let page = (params.page) ? params.page : 1
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + params.id + '?page=' + page
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async list(context, params) {
            let page = (params.page) ? params.page : 1
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDropDownList(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/dropDownList',
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        }
    }

};

export default api
